import type { IRuntimeState } from "../types/state.types"

export class RuntimeStateClass implements IRuntimeState {
    isLoading = [] as string[]
    isEmbed = false
    isGeneratingPdf = false
}
